// extracted by mini-css-extract-plugin
export default {"container":"LxY5YRQeQAPug2ytVTrD","placeholderBox":"d0F8nwEPhFN8eVeSKjv1"};